/*!
 * KoliBri - The accessible HTML-Standard
 */
import { r as registerInstance, h, H as Host } from './index-C_ZKddLG.js';
import { _ as __decorate } from './tslib.es6-QNbPBOk5.js';
import { B as BaseWebComponent } from './base-web-component-D909Fl-Y.js';
import './common-D-vggmh2.js';
import { l as labelProp } from './label-FtX-skKy.js';
import './variant-quote-ClYWonZq.js';
import { C as ClickButtonFC } from './component-WjvIfI-H.js';
import { d as delegateFocus, c as createCtaRef } from './element-interaction-C5-6aPzz.js';
import './normalizers-BNeak4hj.js';
import './_Uint8Array-kJHDjtoP.js';
import './isArray-CcrBs4JM.js';
import './label-w3T7Y2ih.js';
import './bem-registry-3ondDImf.js';
import './element-focus-BQXzaLL9.js';

const clickButtonPropsConfig = {
    required: [labelProp],
};

const KolClickButton = class extends BaseWebComponent {
    constructor(hostRef) {
        super();
        registerInstance(this, hostRef);
        this.buttonRef = createCtaRef();
        this.handleClick = () => {
            console.log(this, 'button clicked');
        };
    }
    watchLabel(value) {
        labelProp.apply(value, (v) => this.setRenderProp('label', v));
    }
    async focus(options) { }
    componentWillLoad() {
        this.initRenderProps(clickButtonPropsConfig);
        labelProp.apply(this._label, (v) => this.setRenderProp('label', v));
    }
    render() {
        return (h(Host, { key: '76c3988fe1fedfac8b4dda8fba68544e4d7092bc' }, h(ClickButtonFC, { key: 'ad43bcb3d2cbf7c89d8c4276dc17b04955a7f28f', label: this.getRenderProp('label'), refButton: this.buttonRef, handleClick: this.handleClick })));
    }
    static get watchers() { return {
        "_label": ["watchLabel"]
    }; }
};
__decorate([
    delegateFocus('buttonRef')
], KolClickButton.prototype, "focus", null);

export { KolClickButton as kol_click_button };
//# sourceMappingURL=kol-click-button.entry.js.map
